import { getFirestore, collection, query, getDocs, onSnapshot } from "firebase/firestore"
import getCollectionPath from '@/services/firestore/getCollectionPath'
import catalogueCommands from '@/commands/catalogueCommands'

const db = getFirestore()
const collectionName = 'jobs/'

function docToInstance(document) {
  const data = document.data()
  if(data.attractivityParameters == undefined) {
    data.attractivityParameters = {
      salary : {center: 100, variance: 50, qmin: 0, qmax: 100, linear: false, saturation: false},
      qvct : {center: 100, variance: 50, qmin: 0, qmax: 100, linear: false, saturation: false},
      finances : {center: 100, variance: 50, qmin: 0, qmax: 100, linear: false, saturation: false},
      reputation : {center: 100, variance: 50, qmin: 0, qmax: 100, linear: false, saturation: false},
    }
  }
  return data ? new Job(document.id, data.type, data.name, data.requirements, data.attractivityParameters, data.multiplier) : null
}

export default class Job {
  constructor(id, type, name, requirements, attractivityParameters, multiplier = 1) {
    this.id = id
    this.type = type
    this.name = name
    this.requirements = requirements
    this.attractivityParameters = attractivityParameters
    this.multiplier = multiplier
  }
  
  static initOne() {
    const attractivityParameters = {
      salary : {center: 100, variance: 50, qmin: 0, qmax: 100, linear: false, saturation: false},
      qvct : {center: 100, variance: 50, qmin: 0, qmax: 100, linear: false, saturation: false},
      finances : {center: 100, variance: 50, qmin: 0, qmax: 100, linear: false, saturation: false},
      reputation : {center: 100, variance: 50, qmin: 0, qmax: 100, linear: false, saturation: false},
    }
    return new Job(null,'production' ,'Nouveau poste', [], attractivityParameters, 1)
  }

  async save() {
    const data = {
      type: this.type,
      name: this.name,
      requirements: this.requirements,
      attractivityParameters: this.attractivityParameters,
      multiplier: this.multiplier
    }

    if (this.id) {
      await catalogueCommands.job.update(this.id, data)
    } else {
      const result = await catalogueCommands.job.create(data)
      this.id = result.id
    }
    return this
  }
  async delete() {
    await catalogueCommands.job.delete(this.id)
  }

  static async listenAll(callback) {
    const docsQuery = query(collection(db, await getCollectionPath(collectionName)))
    onSnapshot(docsQuery, snapshot => {
      const list = []
      snapshot.forEach(document => {
        list.push(docToInstance(document))
      })
      callback(list)
    })
  }

  static async getAll(){
    const documents = await getDocs(collection(db, await getCollectionPath(collectionName)))
    return documents.docs.map(docToInstance)
  }
}
